import { KeyRound } from 'lucide-react'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import CredentialWorkersTable from '@/frontend/components/Credentials/CredentialWorkersTable'
import type { Credential, AssignWorker } from '@/frontend/pages/Dashboard/Integrations/types'

const TH_CLS = 'text-[11px] font-semibold uppercase tracking-[0.08em] text-faint-foreground'
type Props = { credential: Credential; workers: AssignWorker[]; canManage: boolean }

export default function CredentialDetails({ credential, workers, canManage }: Props) {
  return <div className="rounded-xl border border-border bg-card p-6">
    <div className="mb-4 flex items-center gap-2 text-sm font-medium text-foreground">
      <KeyRound className="size-4 text-muted-foreground" strokeWidth={1.75} />
      Campos da credencial ({credential.fields.length})
    </div>
    <Table className="text-[13px]">
      <TableHeader><TableRow>
        <TableHead className={TH_CLS}>Chave</TableHead>
        <TableHead className={TH_CLS}>Valor</TableHead>
      </TableRow></TableHeader>
      <TableBody>{credential.fields.map((field) => <TableRow key={field.key}>
        <TableCell className="font-mono text-[13px] text-foreground">{field.key}</TableCell>
        <TableCell className="font-mono text-[13px] text-muted-foreground">{field.value}</TableCell>
      </TableRow>)}</TableBody>
    </Table>
    <div className="mt-6 border-t border-border pt-6">
      <CredentialWorkersTable workers={workers} credentialId={credential.id} canManage={canManage} />
    </div>
  </div>
}
